import axios from 'axios';
import user from '../utils/user';
import { ORIGIN_SYSTEM } from '@/utils/constants';

export default {
  async getPDFsLinks(chave) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/pdf/auto/links/${chave}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async regenerate(proposalKey, contractSavePdf, typeSavePdf) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/pdf/auto/regenerate`,
        {
          proposalKey,
          contractSavePdf,
          typeSavePdf,
        },
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getQuotationPDFData(idProposta) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations/${idProposta}?contractPdfLog=quotation-auto`,
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_API_VIDA_TOKEN}`,
            'origin-system': ORIGIN_SYSTEM.BPSEG,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getProposalOrPolicyPDFData(idProposta, contractPdfLog) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/auto/quotations/${idProposta}?contractPdfLog=${contractPdfLog}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_API_VIDA_TOKEN}`,
            'origin-system': ORIGIN_SYSTEM.BPSEG,
          },
        },
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getCongenersLabeled() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/congeners`,
        {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_API_VIDA_TOKEN}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
